/**
 * Builds a consistent line chart series config from a hex color.
 * Used by useInvestedCapital and useUnrealizedValue to avoid duplicated config.
 */
function hexToRgba(hex: string, alpha: number): string {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return hex;
  const r = parseInt(result[1], 16);
  const g = parseInt(result[2], 16);
  const b = parseInt(result[3], 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function buildMetricLineSeriesConfig(hexColor: string, emphasisColor?: string) {
  const shadowColor = hexToRgba(hexColor, 0.5);
  const itemShadowColor = hexToRgba(hexColor, 0.6);
  const emphasisShadowColor = hexToRgba(hexColor, 0.8);
  const areaStart = hexToRgba(hexColor, 0.5);
  const areaEnd = hexToRgba(hexColor, 0.05);

  return {
    smooth: true,
    symbol: 'circle',
    symbolSize: 8,
    lineStyle: {
      width: 3,
      shadowBlur: 10,
      shadowColor,
      shadowOffsetY: 4,
    },
    itemStyle: {
      color: hexColor,
      borderColor: '#fff',
      borderWidth: 2,
      shadowBlur: 8,
      shadowColor: itemShadowColor,
    },
    emphasis: {
      itemStyle: {
        color: emphasisColor || hexColor,
        borderColor: '#fff',
        borderWidth: 3,
        shadowBlur: 12,
        shadowColor: emphasisShadowColor,
      },
      lineStyle: {
        width: 4,
      },
    },
    areaStyle: {
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          { offset: 0, color: areaStart },
          { offset: 1, color: areaEnd },
        ],
      },
    },
  };
}
